export const LAST_MONTH_BILLING = "LAST_MONTH_BILLING";

export default (state = null, action) => {
    switch (action.type) {
        case LAST_MONTH_BILLING:
            return action.payload;
        default:
            return state;
    }
}
